import { Input } from 'antd';
import get from 'lodash/get';
import React from 'react';

import I18n from '../../i18n';
import AppContext from '../../services/Context';
import styled from '../../styled-components';

type PropType = {
    type: string;
    className?: string;
    name: string;
    label?: string;
    placeholder?: string;
    value?: any;
    withError?: boolean;
    disabled?: boolean;
    addorn?: any;
    setFieldValue: Function;
    setTouched: Function;
    onFocus: Function;
    onBlur: Function;
};

const { TextArea } = Input;


const TextFieldArea = (props: PropType) => (

    <AppContext.Consumer>
        {({ theme, locale }) => (
            <InputWrapper
                theme={theme}
                className={`form-input-wrapper_${props.name} ${props.className || ''}`}
            >
                <TextArea
                    rows={4}
                    className={`form-input_${props.name} ${props.className || ''}`}
                    name={props.name}
                    placeholder={I18n.l(props.placeholder || '')}
                    disabled={props.disabled}
                    defaultValue=""
                    value={props.value}
                    onChange={(e: any) => {
                        props.setFieldValue(props.name, e.target.value);
                        props.setTouched({ [props.name]: true });
                        // type={props.type}
                    }}
                >
                </TextArea>

            </InputWrapper>
        )}
    </AppContext.Consumer>
);

const InputWrapper = styled.div`
                  display: flex;
                  flex-flow: row nowrap;
                  align-items: center;
                  justify-content: space-between;
  ${({ theme }) => get(theme, 'form.inputWrapper')};
              
  &.search {
                    ${({ theme }) => get(theme, 'form.searchWrapper')};
              }
  &.auth-style {
                    ${({ theme }) => get(theme, 'form.authWrapper')};
              }
            `;

export default TextFieldArea;
